import { axios } from "../config/axios";
import {
  IBoardingHistory,
  IBoardingRequest,
  IBoardingResult,
  IBoardingTrip,
  IBoardingUndo,
  IDepartureCounts,
  IDeparturePassengers
} from "../interfaces/endpoints/IBoarding.types";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";

// A stalled request would hold the scanner; a retry is safe, the same phone gets its own boarding back.
const SCAN_TIMEOUT_MS = 10000;

export const scanTicket = async (
  body: IBoardingRequest
): Promise<IAxiosResponse<IBoardingResult>> =>
  axios.post("v1/Boarding/Scan", body, { timeout: SCAN_TIMEOUT_MS });

export const undoBoarding = async (
  attemptId: number
): Promise<IAxiosResponse<IBoardingUndo>> => axios.post(`v1/Boarding/${attemptId}/Undo`);

export const getBoardingTrips = async (): Promise<IAxiosResponse<IBoardingTrip[]>> =>
  axios.get("v1/Boarding/Trips");

export const getDepartures = async (date: string): Promise<IAxiosResponse<IDepartureCounts[]>> =>
  axios.get(`v1/Boarding/Departures?date=${date}`);

export const getDeparturePassengers = async (
  tripId: number,
  date: string
): Promise<IAxiosResponse<IDeparturePassengers>> =>
  axios.get(`v1/Boarding/Departures/${tripId}/${date}/Passengers`);

export const getBoardingHistory = async (
  uniqueJourneyId: string
): Promise<IAxiosResponse<IBoardingHistory[]>> =>
  axios.get(`v1/Boarding/History/${encodeURIComponent(uniqueJourneyId)}`);
